import React from "react"
import { useIntl, Link } from "gatsby-plugin-intl"

export default function Menu({ id, ariaLabel }) {
  const intl = useIntl()
  return (
    <div>
      <section className="extraContent greyBackground" id={id}>
        <div className="extraContent--container">
          <div className="extraContent--main">
            <nav aria-label={ariaLabel}>
              <ul className="navMenu">
                <li>
                  <span className="navMenu--label">
                    {intl.formatMessage({ id: "menu2" })}
                  </span>
                  <ul>
                    <li>
                      <Link to="/project">
                        {intl.formatMessage({ id: "menu3" })}
                      </Link>
                    </li>

                    <li>
                      <Link to="/partners">
                        {intl.formatMessage({ id: "menu4" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/platform-guide">
                        {intl.formatMessage({ id: "menu5" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        {intl.formatMessage({ id: "menu16" })}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="navMenu--selfCenter">
                  <span className="navMenu--label">
                    {intl.formatMessage({ id: "menu7" })}
                  </span>
                  <ul>
                    <li>
                      <Link to="/good-practices">
                        {intl.formatMessage({ id: "menu8" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/good-practices-user-guide">
                        {intl.formatMessage({ id: "menu9" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/training">
                        {intl.formatMessage({ id: "menu22" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/training-implementation-guide">
                        {intl.formatMessage({ id: "menu23" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/library">
                        {intl.formatMessage({ id: "menu10" })}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li className="navMenu--selfEnd">
                  <span className="navMenu--label">
                    {intl.formatMessage({ id: "menu11" })}
                  </span>
                  <ul>
                    <li>
                      <Link to="/project-logs">
                        {intl.formatMessage({ id: "menu19" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/blog">
                        {intl.formatMessage({ id: "menu18" })}
                      </Link>
                    </li>
                    <li>
                      <Link to="/good-practices/submit">
                        {intl.formatMessage({ id: "menu12" })}
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>
    </div>
  )
}
